import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

/**
 * Hero Class.
 */
export default class Hero extends Base {
  static config = {
    name: 'Hero',
    refs: ['media', 'content'],
  };

  /**
   *
   */
  mounted() {
    this.initParallax();
  }

  /**
   *
   */
  initParallax() {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.$el,
        start: 'top top',
        end: 'bottom top',
        scrub: true,
        invalidateOnRefresh: true,
        onUpdate: (self) => {
          if (self.progress <= 0.05) {
            gsap.set(this.$refs.media, { y: 0 });
          }
        },
      },
    });
    tl.to(this.$refs.media, { y: window.innerHeight / 4, ease: 'none' }, 0);
    tl.to(this.$refs.content, { y: -50, ease: 'none' }, 0);
  }
}
